var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-status" }, [
    !_vm.saving &&
    !_vm.saveFailed &&
    _vm.sectionLockStatus.isLockedForUser &&
    _vm.sectionLockStatus.isLockedForApp &&
    _vm.dirty &&
    _vm.modified
      ? _c("span", [
          _vm._v("\n    " + _vm._s(_vm.$t("Save.UnsavedChanges")) + "\n    "),
          _c(
            "i",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top.center",
                  value: { content: _vm.$t("Save.Save") },
                  expression: "{ content: $t('Save.Save') }",
                  modifiers: { top: true, center: true }
                }
              ],
              staticClass: "icon fas fa-save fa-2x grey",
              attrs: { tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.blur()
                }
              }
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("Save.Save")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.saved && !_vm.dirty
      ? _c("span", [
          _vm._v(
            _vm._s(_vm.$t("Save.Saved")) +
              " " +
              _vm._s(_vm._f("formatDatetime")(_vm.saveTimeStamp, "HH:mm:ss"))
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.saving
      ? _c("span", [
          _c(
            "i",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top.center",
                  value: { content: _vm.$t("Save.Saving") },
                  expression: "{ content: $t('Save.Saving') }",
                  modifiers: { top: true, center: true }
                }
              ],
              staticClass: "icon fas fa-save fa-2x lightgrey",
              attrs: { tabindex: "0" }
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("Save.Saving")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.saveFailed
      ? _c("span", [
          _c(
            "i",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top.center",
                  value: { content: _vm.$t("Save.Failed") },
                  expression: "{ content: $t('Save.Failed') }",
                  modifiers: { top: true, center: true }
                }
              ],
              staticClass: "icon fas fa-save fa-2x orange",
              attrs: { tabindex: "0" }
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("Save.Failed")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.sectionLockStatus.isLocked
      ? _c("span", [
          _vm.sectionLockStatus.isLockedState
            ? _c(
                "i",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top.center",
                      value: { content: _vm.$t("Save.LockedState") },
                      expression: "{ content: $t('Save.LockedState') }",
                      modifiers: { top: true, center: true }
                    }
                  ],
                  staticClass: "icon fas fa-lock fa-2x orange",
                  attrs: { tabindex: "0" }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Save.LockedState")))
                  ])
                ]
              )
            : _vm.sectionLockStatus.isPastDeadline
            ? _c(
                "i",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top.center",
                      value: { content: _vm.$t("Save.PastDeadline") },
                      expression: "{ content: $t('Save.PastDeadline') }",
                      modifiers: { top: true, center: true }
                    }
                  ],
                  staticClass: "icon fas fa-lock fa-2x orange",
                  attrs: { tabindex: "0" }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Save.PastDeadline")))
                  ])
                ]
              )
            : !_vm.sectionLockStatus.isLockedForUser
            ? _c("span", [
                _c("span", { staticClass: "d-none d-xl-inline" }, [
                  _vm._v(_vm._s(_vm.lockedForAnotherUserReason))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "d-inline d-xl-none" }, [
                  _vm._v(_vm._s(_vm.$t("Save.Locked")))
                ]),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left",
                      value: { content: _vm.lockedForAnotherUserReason },
                      expression: "{ content: lockedForAnotherUserReason }",
                      modifiers: { left: true }
                    }
                  ],
                  staticClass: "icon fas fa-lock fa-2x orange",
                  attrs: { tabindex: "0" }
                })
              ])
            : !_vm.sectionLockStatus.isLockedForApp
            ? _c("span", [
                _c("span", { staticClass: "d-none d-xl-inline" }, [
                  _vm._v(_vm._s(_vm.$t("Save.LockedForOtherApp")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "d-inline d-xl-none" }, [
                  _vm._v(_vm._s(_vm.$t("Save.Locked")))
                ]),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left",
                      value: { content: _vm.$t("Save.LockedForOtherApp") },
                      expression: "{ content: $t('Save.LockedForOtherApp') }",
                      modifiers: { left: true }
                    }
                  ],
                  staticClass: "icon fas fa-lock fa-2x orange",
                  attrs: { tabindex: "0" }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.openLock }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("Save.OpenLock")) +
                        "\n        "
                    ),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("-. " + _vm._s(_vm.$t("Save.OpenLockDescription")))
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }